import { createStyles, makeStyles } from '@material-ui/core/styles';
import Colors from '../../layout/theme/utils/colors';
import { Colors as NextColors } from '../../layout/theme-next';

const useDeviationProcedureStyles = makeStyles((theme) =>
  createStyles({
    panelBorder: {
      marginBottom: theme.spacing(0.625),
      border: `1px solid ${Colors.gray_goose}`,
      borderRadius: '4px',
    },
    panelSummary: {
      flexDirection: 'row-reverse',
      padding: theme.spacing(0, 2),
      minHeight: '48px',
      alignItems: 'center',
      '& .MuiAccordionSummary-expandIcon': {
        marginRight: theme.spacing(0.5),
        marginLeft: 0,
        padding: theme.spacing(1),
      },
      '& .Mui-expanded': {
        transform: 'rotate(0deg)',
      },
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    stepCountLabel: {
      fontSize: 12,
      color: Colors.hint_gray,
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(1),
    },
    deviatedBadge: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: NextColors.error,
      backgroundColor: NextColors.errorHighlight,
      borderRadius: 4,
      padding: theme.spacing(0.5, 1),
      marginLeft: theme.spacing(1),
      whiteSpace: 'nowrap',
    },
    // Deviation-only: the shared section label and Kendo table headers are grey; Figma has them black
    root: {
      '& legend > div, & .k-header, & .k-column-title': {
        color: NextColors.textBlack,
      },
    },
    expandAllButton: {
      color: NextColors.primary,
      fontSize: 14,
      fontWeight: 600,
      textTransform: 'none',
      padding: 0,
      minWidth: 0,
      marginBottom: theme.spacing(1.5),
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    headerExpanded: {
      '& $stepLabelText, & $mpiLabelText': {
        color: NextColors.primary,
      },
    },
    stepToggle: {
      marginBottom: theme.spacing(1.875),
    },
    stepToggleRow: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
    },
    stepToggleLabel: {
      marginLeft: theme.spacing(1),
      fontSize: 14,
    },
    procedureHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1),
    },
    procedureLabel: {
      fontSize: 14,
      fontWeight: 700,
    },
    showDiffLabel: {
      fontSize: 14,
      marginLeft: theme.spacing(0.5),
    },
    stepCaption: {
      fontWeight: 600,
    },
    stepLabelText: {
      fontSize: 16,
      fontWeight: 600,
      color: NextColors.textBlack,
      whiteSpace: 'nowrap' as const,
    },
    mpiLabelText: {
      fontSize: 16,
      fontWeight: 400,
      color: NextColors.textBlack,
      marginLeft: theme.spacing(0.5),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap' as const,
    },
    sortableItem: {
      position: 'relative',
    },
    sortableItemDragging: {
      zIndex: 6,
    },
    accordionDetails: {
      display: 'block',
    },
  }),
);

export default useDeviationProcedureStyles;
